module.exports = __webpack_public_path__ + "img/1.d47a8a2e.webp";